

import InputRegion from "../../components/inputRegion";
import Navigation from "../../components/navigation";
import Notice from "../../components/notices/notice";
import Quicks from "../../components/quicks";
export default {
    components: { Quicks, Notice, Navigation, InputRegion },
    auth: false,
    data() {
        return {
            form: {
                page: 1,
                started_at: "",
                finished_at: "",
                orderBy: "created_at",
                district_id: this.$store.state.district ? this.$store.state.district.id : "",
            },

            items: {
                data: [],
                meta: {
                    current_page: 1,
                    last_page: 1,
                },
                links: {}
            },

            errors: {}
        }
    },
    methods: {
        loadMore(state) {
            if (this.items.meta.current_page <= this.items.meta.last_page) {
                this.form.page += 1;

                this.$axios.get("/api/notices", {
                    params: this.form
                }).then(response => {
                    this.items = {
                        ...response.data,
                        data: [...this.items.data, ...response.data.data]
                    };

                    state.loaded();
                });
            }
        },

        getItems() {
            this.form.page = 1;

            this.$axios.get("/api/notices", {
                params: this.form
            }).then(response => {
                this.items = response.data;
            });
        },

        removed(item) {
            this.items.data = this.items.data.filter(itemData => itemData.id != item.id);
        },


    },

    computed: {
        isManager() {
            if (!this.$auth.user)
                return false;

            if (!this.$auth.hasScope("manager"))
                return false;

            return true;
        }
    },

    mounted() {
        this.getItems();
        if (this.$store.state.isFlutter) {
            if (window.hideBtn) {
                window.hideBtn.postMessage(`hide:${this.$route.path}`);
            }
            if (window.flutterSetComponents) {
                window.flutterSetComponents.postMessage('/posts');
            }
        }

        if (this.$auth.user) {
            this.$axios.patch("/api/users/readNotice");
            this.$auth.setUser({
                ...this.$auth.user,
                has_new_notice: 0
            });
        }
    }
}
